import React, { useId } from 'react'

/**
 * Wspólny przełącznik zamiast zwykłego checkboksa przeglądarki (decyzja właściciela 2026-10-11: „jak dodajemy
 * checkboxy, to nowoczesne”). Pod spodem prawdziwy `<input type="checkbox">` (schowany, `peer`), więc klawiatura,
 * czytniki ekranu i testy (`getByRole('checkbox', { name })`) działają jak przy zwykłym polu.
 *
 * `kolor`: klasa tła włączonego toru (domyślnie niebieski; zielony dla „sukcesów” jak podpisana umowa).
 * `opis`: drobny tekst pod etykietą. `rozmiar`: 'sm' (w listach) albo 'md'.
 */
const Przelacznik = ({ etykieta, opis, wartosc, onZmiana, kolor = 'bg-blue-600', rozmiar = 'md', disabled = false, className = '', children }) => {
  const id = useId()
  const tor = rozmiar === 'sm' ? 'h-4 w-7' : 'h-5 w-9'
  const galka = rozmiar === 'sm' ? 'h-3 w-3 peer-checked:translate-x-3' : 'h-4 w-4 peer-checked:translate-x-4'
  return (
    <label htmlFor={id} className={`group inline-flex cursor-pointer select-none items-start gap-2.5 ${disabled ? 'cursor-not-allowed opacity-60' : ''} ${className}`}>
      <span className="relative mt-0.5 inline-flex flex-shrink-0">
        <input id={id} type="checkbox" className="peer sr-only" checked={Boolean(wartosc)} disabled={disabled}
               onChange={(e) => onZmiana(e.target.checked)} />
        <span className={`${tor} rounded-full transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500 peer-focus-visible:ring-offset-1 ${wartosc ? kolor : 'bg-gray-300'}`} />
        <span className={`absolute left-0.5 top-0.5 ${galka} rounded-full bg-white shadow transition-transform`} />
      </span>
      <span className="min-w-0">
        <span className="block text-sm text-gray-800">{etykieta}{children}</span>
        {opis && <span className="block text-xs text-gray-500">{opis}</span>}
      </span>
    </label>
  )
}

export default Przelacznik
